import { APP } from '../constants';

export const toggleUIControls = () => ({
  type: APP.TOGGLE_CONTROLS,
});

export const showNotificationMessage = (title, message, messageType = 'info') => ({
  type: APP.NOTIFICATION.SHOW,
  title,
  message,
  messageType,
});

export const updateNotificationMessage = newParams => ({
  type: APP.NOTIFICATION.UPDATE,
  newParams,
});

export const closeNotificationMessage = () => ({
  type: APP.NOTIFICATION.CLOSE,
});

export const showLoadingIndicator = () => ({
  type: APP.SHOW_LOADING,
});

export const hideLoadingIndicator = () => ({
  type: APP.HIDE_LOADING,
});



// WEBPACK FOOTER //
// ./src/store/actions/app.actions.js